import React, { useContext, useEffect, useState, useRef } from "react";
//import classes from "./pricingDropdowns.module.scss";
import classes from "../dashboardComponents/DashboardComponents.module.scss";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpIcon from '@mui/icons-material/Help';
import { OrgIdContext } from "../../store/orgId_context";
import { useTranslation } from "react-i18next";
import OutboxIcon from '@mui/icons-material/Outbox';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import QrCodeIcon from '@mui/icons-material/QrCode';
import Button from "../UI/Button";
import { Dialog, DialogActions, DialogContent, DialogTitle, Switch, LinearProgress, Checkbox } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import { useQuery } from "@tanstack/react-query";
import { DDD, E2Data } from "../../lib/ddd/ddd";
import {Checkout} from "@fung-sdk/checkout"
import { NotificationManager} from 'react-notifications';
import PaymentIcon from '@mui/icons-material/Payment';
import GenericModal from "../UI/GenericModal";
import CurrencyTextField from '@lupus-ai/mui-currency-textfield'
import useInterval from "../../lib/useInterval";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RecurringCard from "./RecurringCard";
import UnscheduledCardMethod from "./UnscheduledCardMethod";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const PaymentMethods = ({goToPackages}) => {
    const {sessionInfo, setSessionInfoHandler} = useContext(OrgIdContext);
    const [addCardLoading, setAddCardLoading] = useState();
    const [showPaymentModal, setShowPaymentModal] = useState();
    const [addUnscheduledCheckoutStatus, setAddUnscheduledCheckoutStatus] = useState();
    const myElementRef = useRef(null);
    const [onCardDelete, setOnCardDelete] = useState();
    const [error, setError] = useState();
    const [waitingForAuto, setWaitingForAuto] = useState();
    const {t} = useTranslation();

    const {isPending , data, refetch } = useQuery({
        queryKey: ["EUeInvoices.GetPaymentMethods", "payments"],
        queryFn: () => ddd.Rpc_ExecuteExtension("EUeInvoices.GetPaymentMethods", {})
    })

    useInterval(() => {
        refetch();
    }, 15000);

    const onConfirmCardDelete = () => {
        if(!onCardDelete) return;
        deleteCard({...onCardDelete});
        setOnCardDelete(null);
    }

    const deleteCard = (card) => {
        if(!card) return NotificationManager.error(t("An error occured. Please contact support."), t("Error"), 5000);
        const e2data = new E2Data("EU_FungCheckout");
        e2data.filter = `Id='${card.Id}'`;
        e2data.values = {"UnscheduledActive": false};
        e2data.Modify().then(res => {
            refetch();
        });
    }

    useEffect(() => {
        if(showPaymentModal){
            const checkout = new Checkout({
                checkoutId: showPaymentModal?.id,
                containerId: "paymentContainerModal",
                env: "sandbox",
                //env: mode,
            })
            checkout.on("checkout:loaded", (e) => {
                //console.log(e);
            })
    
            checkout.on("checkout:completed", (e) => {
                checkout.removeAllListeners();
                onUnscheduledCompleted(showPaymentModal?.id);
                clearIframeDiv();
                setShowPaymentModal(false);
            })
    
            checkout.on("checkout:invalid", (e) => {
                checkout.removeAllListeners();
                setErrorMsg(t("Payment was invalid"));
                clearIframeDiv();
                setShowPaymentModal(false);
            })
    
            checkout.on("checkout:failed", (e) => {
                checkout.removeAllListeners();
                setErrorMsg(t("Payment failed"));
                clearIframeDiv();
                setShowPaymentModal(false);
            })
            checkout.render();
        }
    }, [showPaymentModal]);

    const onUnscheduledCompleted = (checkoutId) => {
        refetch();
        setAddUnscheduledCheckoutStatus(checkoutId);
    };

    const onAddPaymentCardClick = () => {
        setAddCardLoading(true);
        ddd.Rpc_ExecuteExtension("EUeInvoices.CreateFungCheckout", {"Type": "Unscheduled"}).then(res => {
            setAddCardLoading(false);
            if(!res?.result?.id) return NotificationManager.error(t("Unable to create a new checkout"), t("Error"), 5000);
            setShowPaymentModal(res?.result);
        }).catch(err => {
            setAddCardLoading(false);
            setShowPaymentModal(false);
            NotificationManager.error(t("An unknown error occured"), t("Error"), 5000);
        });
    }

    const clearIframeDiv = () => {
        const container = document.getElementById("paymentContainerModal");
        if (container == null)return;

        container.innerHTML = null;
    }

    const setErrorMsg = (msg) => {
        setError(msg);
        setTimeout(() => {
            setError(null);
        }, 3000);
    }

    const getFormattedAmount = (amount) => {
        try {
            return new Intl.NumberFormat('de-DE', { 
                style: 'currency', 
                currency: 'EUR' 
            }).format(amount);
        }catch(e){
            return amount;
        }
    }

    const onDeleteClick = (card) => {
        setOnCardDelete(card);
    }

    return (<>
        <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={onCardDelete}>
            <DialogTitle>{t("Confirm cancel")}</DialogTitle>
            <DialogContent dividers>
            {t("Are you certain you want to remove this payment method")}
            </DialogContent>
            <DialogActions>
                <Button className="ps-2 pe-2" autoFocus onClick={() => setOnCardDelete(null)}>
                {t("Cancel")}
                </Button>
                <Button className="ps-2 pe-2" onClick={onConfirmCardDelete}>Ok</Button>
            </DialogActions>
        </Dialog>
        <Row>
            <Col className="">
                {addUnscheduledCheckoutStatus && <CheckoutUscheduledStatus checkoutId={addUnscheduledCheckoutStatus} onCompleted={() => {setAddUnscheduledCheckoutStatus(null); refetch();}}/>}
                <div className={classes.container} style={{maxHeight:"none", height:"auto"}}>
                    <div className="mt-1 fs-5 fw-bold d-flex">
                        <div>{t("Saved payment methods")}</div>
                        <div className="ms-auto">
                            <Button className="ps-2 pe-2" style={{fontSize:"1rem"}} onClick={onAddPaymentCardClick} disabled={addCardLoading}><AddCircleOutlineIcon className="me-2"/>{t("Add payment card")}</Button>
                        </div>
                    </div>
                    <Row>
                        {data?.result?.map((card, index) => {
                            if(!card.Unscheduled && !card.UnscheduledActive) return null;
                            return <UnscheduledCardMethod card={card} key={index} onDeleteClick={onDeleteClick}/>
                        })}
                    </Row>
                    {/* <div className="d-flex ">
                        {data?.result?.map((card, index) => {
                            if(!card.Unscheduled && !card.UnscheduledActive) return null;
                            return <UnscheduledCardMethod card={card} key={index} onDeleteClick={onDeleteClick}/>
                        })}
                    </div> */}
                    {error && <div className="alert alert-danger mt-2" role="alert">
                        {error}
                    </div>}
                </div>
            </Col>
        </Row>
        <GenericModal show={showPaymentModal} onHide={() => setShowPaymentModal(false)} title="Add funds" icon={<PaymentIcon/>}>
            <div id="paymentContainerModal" style={{textAlign:"center"}} ref={myElementRef}></div>
        </GenericModal>
        </>);
};

export default PaymentMethods;

const CheckoutUscheduledStatus = ({checkoutId, onCompleted}) => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [data, setData] = useState();
    const [completed, setCompleted] = useState(false);

    useInterval(() => {
        if(!checkoutId) return;
        if(completed) return;
        ddd.Rpc_ExecuteExtension("EUeInvoices.GetCheckoutTransactionStatus", {"type": "checkout","Id": checkoutId}).then(res => {
            if(!res?.result || res?.result?.count===0) return;
            let _data = res?.result?.data[0];
            if(!_data) return;
            try{
                _data.ResponseJS = JSON.parse(_data.Response);
            }catch(e){
            }
            setData(_data);

            if(isComplete(_data)){
                setLoading(false);
                setCompleted(true);
                if(onCompleted) setTimeout(() => onCompleted(), 5000);
            }
            if(isErrored(_data)){
                setLoading(false);
                setError(isErrored(_data));
                setCompleted(true);
                if(onCompleted) setTimeout(() => onCompleted(), 10000);
            }
        }).catch(err => {
            setLoading(false);
            setError(t("An unknown error occured"));
        });
    }, 5000);

    const isPaymentCredited = (d) => {
        return d?.Credited === true;
    }

    const latestCheckout = (d) => {
        return d?.ResponseJS?.events && [...d.ResponseJS.events].reverse().find(e => e.resourceType === "CHECKOUT");
    }
    const latestTX = (d) => {
        return d?.ResponseJS?.events && [...d.ResponseJS.events].reverse().find(e => e.resourceType === "TX");
    }
    const latestThreeds = (d) => {
        return d?.ResponseJS?.events && [...d.ResponseJS.events].reverse().find(e => e.resourceType === "THREEDS");
    }
    const isComplete = (d) => {
        return d?.ResponseJS?.events?.find(e => e.resourceType === "TX" && e.status === "AUTHORIZED");
    }
    const isErrored = (d) => {
        return d?.ResponseJS?.events?.find(e => e.resourceType === "TX" && (e.status === "DECLINED" || e.status === "ERROR"));
    }

    const getStatus = (d) => {
        if(latestTX(d)) return t("Transaction status")+": "+latestTX(d).status;
        if(latestThreeds(d)) return t("3D secure status")+": "+latestThreeds(d).status;
        if(latestCheckout(d)) return t("Checkout status")+": "+latestCheckout(d).status;
        return t("Unknown status");
    }

    const getPaymentStatusIcon = (d) => {
        if(isComplete(d)) return <CheckCircleIcon className={classes["main-green"]}/>
        if(isErrored(d)) return <ErrorIcon className={classes["main-red"]}/>
        return <HourglassBottomIcon />;
    }

    return (
        <div class="alert alert-primary mt-2" role="alert">
            {loading && <LinearProgress sx={{
                            '& .MuiLinearProgress-bar': {
                            backgroundColor: '#005683',
                            },
                            backgroundColor: '#b1d1e1',
                        }}/>}
            <div className="mb-2">{t("Please wait while the authenticate the payment method")}</div>
            {data && <div className="d-flex fs-7">
                <div>{getStatus(data)}</div>
                <div className="ms-auto">{getPaymentStatusIcon(data)}</div>
            </div>}
            {error && <div>{error}</div>}
        </div>
    );
};
